import { useQuery, UseQueryResult } from 'react-query';
import { GLMKiloFlowRetrieve } from 'types';
import { client } from 'utils/api-client';

function useGLMKiloFlow(
  glmKiloFlowId: string | undefined | null,
): UseQueryResult<{ data: GLMKiloFlowRetrieve }> {
  return useQuery(['glm-kilo-flows', glmKiloFlowId], () => client.get(`glm-kilo-flows/${glmKiloFlowId}/`), {
    enabled: !!glmKiloFlowId,
  });
}

export default useGLMKiloFlow;
